import { fetchWebPost } from "../../api/webpage";
import { CmsDocumentPage } from "./CmsDocumentPage";

export const WebPost = () => (
  <CmsDocumentPage kind="post" fetchDocument={fetchWebPost} />
);

export default WebPost;
